export default __webpack_public_path__ + "static/media/songCompassWhiteLogo.8f758bd1.png";